module.exports = __webpack_public_path__ + "static/media/NotoSans-Light.18923621.woff";